import { ENV } from 'other/config';
import { TSelectOption } from 'types';

/**/
const VESSEL_TYPE_LIST_AF: TSelectOption<number>[] = [
  { label: 'Live fish carrier', value: 19 },
  { label: 'Feeding carrier', value: 20 },
  { label: 'Cargo', value: 11 },
  { label: 'Ensilage', value: 27 },
  { label: 'Reefer', value: 31 },
  { label: 'Oil tanker', value: 21 },
  { label: 'Harvest', value: 18 },
  { label: 'Workboat', value: 15 },
  { label: 'Service', value: 17 },
  { label: 'Floating platform', value: 16 },
  { label: 'Newbuilding (AF)', value: 26 }
];

/**/
const VESSEL_TYPE_LIST_FF: TSelectOption<number>[] = [
  { label: 'Pelagic', value: 2 },
  { label: 'Freezing trawler', value: 4 },
  { label: 'Long liner', value: 5 },
  { label: 'Trawler', value: 3 },
  { label: 'Coast <20m', value: 10 },
  { label: 'Tuna', value: 9 },
  { label: 'Krill', value: 8 },
  { label: 'Shellfish and Crustaceans', value: 6 },
  { label: 'Coast guard', value: 14 },
  { label: 'Cargo', value: 11 },
  { label: 'Research', value: 13 },
  { label: 'Processing vessel', value: 12 },
  { label: 'Oil tanker', value: 21 },
  { label: 'Offshore', value: 25 },
  { label: 'Ice Breaker', value: 22 },
  { label: 'Newbuilding (FF)', value: 23 },
  // { label: 'Seals', value: 7 },
  { label: 'Combined Seine Trawler', value: 28 },
  { label: 'Coast >20m', value: 29 },
  { label: 'Bulk', value: 30 },
  { label: 'Reefer', value: 31 },
  { label: 'Ferry', value: 32 },
  { label: 'Cruise', value: 33 },
  { label: 'Gas Tanker', value: 34 },
  { label: 'Supply', value: 35 },
  { label: 'Platform', value: 36 },
  { label: 'Windmill', value: 37 },
  { label: 'SSV', value: 38 },
  { label: 'Multipurpose', value: 39 },
  { label: 'Drill vessel', value: 40 },
  { label: 'Tugboat', value: 41 },
  { label: 'SAR', value: 42 },
  { label: 'Other', value: 24 }
];

/**/
export const VESSEL_TYPE_LIST_obsolete: TSelectOption<number>[] = ENV.IS_AF
  ? VESSEL_TYPE_LIST_AF
  : VESSEL_TYPE_LIST_FF;

/**/
export type TVesselTypeGroup = {
  label: string;
  type: EVesselTypeGroup;
  items: TSelectOption<number>[];
};
export enum EVesselTypeGroup {
  AQUACULTURE = 'AQUACULTURE',
  CARGO = 'CARGO',
  FISHING = 'FISHING',
  OFFSHORE = 'OFFSHORE',
  SUPPORT = 'SUPPORT'
}

/**/
const VESSEL_TYPES_AF: TVesselTypeGroup[] = [
  {
    label: 'Cargo and Transport',
    type: EVesselTypeGroup.CARGO,
    items: [
      { label: 'Cargo', value: 11 },
      { label: 'Bulk', value: 30 },
      { label: 'Ensilage', value: 27 },
      { label: 'Feeding carrier', value: 20 },
      { label: 'Reefer', value: 31 },
      { label: 'Oil tanker', value: 21 }
    ]
  },
  {
    label: 'Aquaculture',
    type: EVesselTypeGroup.AQUACULTURE,
    items: [
      { label: 'Workboat', value: 15 },
      { label: 'Floating platform', value: 16 },
      { label: 'Service', value: 17 },
      { label: 'Harvest', value: 18 },
      { label: 'Live fish carrier', value: 19 },
      { label: 'Newbuilding (AF)', value: 26 }
    ]
  }
];

/**/
const VESSEL_TYPES_FF: TVesselTypeGroup[] = [
  {
    label: 'Fishing',
    type: EVesselTypeGroup.FISHING,
    items: [
      { label: 'Pelagic', value: 2 },
      { label: 'Freezing trawler', value: 4 },
      { label: 'Trawler', value: 3 },
      { label: 'Long liner', value: 5 },
      { label: 'Coast <20m', value: 10 },
      { label: 'Coast >20m', value: 29 },
      { label: 'Combined Seine Trawler', value: 28 },
      { label: 'Tuna', value: 9 },
      { label: 'Krill', value: 8 },
      { label: 'Shellfish and Crustaceans', value: 6 },
      { label: 'Processing vessel', value: 12 }
    ]
  },
  {
    label: 'Cargo and Transport',
    type: EVesselTypeGroup.CARGO,
    items: [
      { label: 'Cargo', value: 11 },
      { label: 'Bulk', value: 30 },
      { label: 'Reefer', value: 31 },
      { label: 'Ferry', value: 32 },
      { label: 'Cruise', value: 33 },
      { label: 'Oil tanker', value: 21 },
      { label: 'Gas Tanker', value: 34 }
    ]
  },
  {
    label: 'Support, Service and Other',
    type: EVesselTypeGroup.SUPPORT,
    items: [
      { label: 'Coast guard', value: 14 },
      { label: 'Ice Breaker', value: 22 },
      { label: 'Research', value: 13 },
      { label: 'Newbuilding (FF)', value: 23 },
      { label: 'Tugboat', value: 41 },
      { label: 'SAR', value: 42 },
      { label: 'Other', value: 24 }
    ]
  },
  {
    label: 'Offshore',
    type: EVesselTypeGroup.OFFSHORE,
    items: [
      { label: 'Supply', value: 35 },
      { label: 'Platform', value: 36 },
      { label: 'Windmill', value: 37 },
      { label: 'SSV', value: 38 },
      { label: 'Multipurpose', value: 39 },
      { label: 'Drill vessel', value: 40 }
    ]
  }
];

/**/
export const VESSEL_TYPES_TREE: TVesselTypeGroup[] = ENV.IS_AF
  ? VESSEL_TYPES_AF
  : VESSEL_TYPES_FF;

/**/
export const VESSEL_TYPE_LIST = VESSEL_TYPES_TREE.flatMap(
  (g: TVesselTypeGroup) => g.items
);

/**/
export const VESSEL_TYPE_IDS = VESSEL_TYPE_LIST.map(
  (item: TSelectOption<number>) => item.value
).sort();
